import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { List } from 'immutable';
import { isEmpty } from 'lodash';
import 'react-medium-image-zoom/dist/styles.css';
import axios from 'axios';
import styles from '../ticket-spot.scss';
import { WIX_INSTANCE_PARAMS } from '~actions/component_actions';
import { CheckoutProcessStepper, StepButtonWrapper } from 'widget/event_components/checkout-stepper';
import { filterConnectedTickets, hasAvailableTicketsInCart } from 'widget/event_components/Ticket/utils';
import { errorHander } from 'utils/error-handler';
import { TicketCheckoutForm } from 'widget/event_components/Ticket/components/TicketCheckoutForm';
import { TicketForm } from 'widget/event_components/Ticket/components/Form';
import { Payment } from 'widget/event_components/Ticket/components/Payment';
import { ConfirmationIframe } from 'widget/event_components/Ticket/components/ConfirmationIframe';
import * as E from './elements';
import cn from 'classnames';
import DatetimeCheckoutController from './components/Datetime';
import { waitlistEventFull } from './waitlist_utils';
import { createRef } from 'react';
import { validatePrice } from './components/PayWhatYouWant';
import { trackTicketPage, trackPaymentAttempt, trackPaymentResult, trackCustomerInfo } from '../../../utils/journey-tracking';
// import { InvisibleRecaptcha } from '../../../components/InvisibleRecaptcha';

const parsedSearch = new URLSearchParams(window.location.search);
const isShopifyEvent = parsedSearch.get('widgetType') === 'shopify';

const scrollToTicketElement = () => {
  const el = document.querySelector(`.checkout-success-text`);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export class Ticket extends React.Component {
  constructor(props) {
    super(props);
    const tickets = this.props.tickets || List();
    this.checkoutFormContainerRef = createRef();
    // this.recaptchaRef = createRef();
    const attendee = props.session && props.session.attendee ? props.session.attendee : {};

    const dateSelectionRequired =
      (props.settings.get('multiDayDateSelector') && props.event.get('is_series_event')) || props.event.get('is_time_based');
    const isWaitlistAtCapacity = dateSelectionRequired ? false : waitlistEventFull(props.event, tickets);
    this.state = {
      minHeight: 0,
      cart: isWaitlistAtCapacity ? {} : this.setupInitialCart(tickets),
      isWaitlist: isWaitlistAtCapacity,
      event: props.event,
      tickets,
      ticketOverrides: {},
      saving: false,
      complete: false,
      attendees: attendee ? [attendee] : [],
      errors: {},
      custom_answers: {},
      orderError: false,
      loadingCheckoutValues: false,
      confirmMessage: '',
      orderConfirmationUrl: '',
      errorMessage: '',
      selectedCard: props.session && props.session.cards ? props.session.cards[0] : null,
      promo_code: '',
      access_code: '',
      session: props.session,
      currentStep: 0,
      stepBeforeWaitlist: null,
      eventBeforeWaitlist: null,
      ticketsBeforeWaitlist: null,
      occurrenceDate: undefined,
      // recaptchaLoaded: false,
      // Seating chart state
      seatSelections: [],
      seatHoldToken: null,
      hasSeatingChart: false,
      seatingChartLoading: true,
      manualCart: {}, // Track manual ticket selections separately from seat selections
    };
    this.trackViewTicket();
  }

  componentDidMount() {
    const { onResizeComponent } = this.props;
    const { event } = this.state;

    this.setState({
      loadingCheckoutValues: true,
    });

    // Check if event has a seating chart
    const seatingConfigUrl = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${event.get('id')}/seating${WIX_INSTANCE_PARAMS}`;
    axios
      .get(seatingConfigUrl, { withCredentials: true })
      .then(({ data }) => {
        if (data.success && data.config) {
          this.setState({
            hasSeatingChart: true,
            seatingChartLoading: false,
          });
        } else {
          this.setState({
            hasSeatingChart: false,
            seatingChartLoading: false,
          });
        }
      })
      .catch(() => {
        // No seating chart available, proceed normally
        this.setState({
          hasSeatingChart: false,
          seatingChartLoading: false,
        });
      });

    const checkoutSummaryUrl = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${event.get('id')}/checkout${WIX_INSTANCE_PARAMS}`;
    axios
      .post(
        checkoutSummaryUrl,
        {
          cart: this.state.cart,
          promo_code: '',
          access_code: '',
          ticket_overrides: this.state.ticketOverrides,
        },
        { withCredentials: true }
      )
      .then(({ data }) => {
        this.setState({
          checkoutValues: data,
          loadingCheckoutValues: false,
        });
        onResizeComponent && onResizeComponent();
      });
    this.updateMinHeight();
  }

  componentDidUpdate(prevProps, prevState) {
    // Compare props and state to see if an update is necessary
    if (
      this.state.currentStep !== prevState.currentStep ||
      this.state.complete !== prevState.complete ||
      this.state.isWaitlist !== prevState.isWaitlist
    ) {
      this.updateMinHeight();
    }
  }

  setupInitialCart = (tickets) => {
    if (tickets.size === 1 && tickets.getIn([0, 'quantity_total']) > 0 && tickets.some((ticket) => ticket.get('status') === 'onsale')) {
      return {
        [tickets.getIn([0, 'id'])]: 1,
      };
    }

    return {};
  };
  getSeatQuantities() {
    const seatQuantities = {};
    this.state.seatSelections.forEach((seat) => {
      if (seat.ticketId) {
        seatQuantities[seat.ticketId] = (seatQuantities[seat.ticketId] || 0) + 1;
      }
    });
    return seatQuantities;
  }

  setCustomField =
    (index) =>
    (type, { mapping }) =>
    (question, answer, checked) => {
      const { onResizeComponent } = this.props;
      if (mapping) {
        this.setField(index)(mapping, answer);
      }
      if (type === 'checkbox') {
        const currentChecksBase = this.state.attendees[index]?.custom_answers ? this.state.attendees[index]?.custom_answers[question] : [];
        const currentChecks = currentChecksBase || [];
        const result = checked ? currentChecks.concat(answer) : currentChecks.filter((c) => c !== answer);
        this.setState({
          attendees: this.state.attendees.map((attendee, i) => {
            if (i === index) {
              return {
                ...attendee,
                custom_answers: {
                  ...attendee.custom_answers,
                  [question]: result,
                },
              };
            }
            return attendee;
          }),
        });
        onResizeComponent && onResizeComponent();
        return;
      }
      this.setState({
        attendees: this.state.attendees.map((attendee, i) => {
          if (i === index) {
            return {
              ...attendee,
              custom_answers: {
                ...attendee.custom_answers,
                [question]: answer,
              },
            };
          }
          return attendee;
        }),
      });
      onResizeComponent && onResizeComponent();
    };

  setField = (index) => (field, value) => {
    const updatedAttendees = {
      attendees: this.state.attendees.map((attendee, i) => {
        if (i === index) {
          return {
            ...attendee,
            form: {
              ...attendee.form,
              [field]: value,
            },
          };
        }
        return attendee;
      }),
    };
    this.setState(updatedAttendees);

    const attendee = updatedAttendees.attendees[index];
    if (attendee.errors && attendee.errors[field]) {
      this.setState({
        attendees: updatedAttendees.attendees.map((a, i) => {
          if (i === index) {
            return {
              ...a,
              errors: {
                ...this.state.errors,
                [field]: null,
              },
              form: {
                ...a.form,
              },
            };
          }
          return a;
        }),
      });
    }
  };

  setConfirmationEmail = ({ message, order_confirmation_url }) => {
    const { onResizeComponent } = this.props;
    this.setState(
      {
        saving: false,
        complete: true,
        confirmMessage: message,
        orderConfirmationUrl: order_confirmation_url,
      },
      () => {
        if (onResizeComponent) {
          onResizeComponent(true);
        }
        scrollToTicketElement();
      }
    );
  };

  setOccurrencesDate = (date) => {
    this.setState({
      occurrenceDate: date,
    });
  };

  trackViewTicket = () => {
    const { event } = this.state;

    // Prepare event data
    const eventData = {
      event_category: 'Ticket',
      event_label: event.get('name'),
      currency: event.get('currency'),
    };

    // Google Analytics tracking
    if (window.gtag) {
      window.gtag('event', 'begin_ticket_selection', eventData);
    }

    // Facebook Pixel tracking
    if (window.fbq) {
      window.fbq('trackCustom', 'BeginTicketSelection', {
        content_name: event.get('name'),
        content_category: 'Ticket',
        contents: eventData.event_label,
        currency: eventData.currency,
      });
    }

    // Journey tracking
    trackTicketPage(event);
  };

  updateMinHeight = () => {
    if (this.checkoutFormContainerRef.current && !isShopifyEvent) {
      const currentHeight = this.checkoutFormContainerRef.current.offsetHeight;
      this.setState((prevState) => ({
        minHeight: Math.max(prevState.minHeight, currentHeight),
      }));
    }
  };

  handleCheckoutError = ({ errorMessage }) => {
    const { onResizeComponent } = this.props;
    this.setState(
      {
        saving: false,
        complete: false,
        orderError: true,
        errorMessage: errorMessage || 'There was a problem making the payment. Please ensure all your payment details are correct',
      },
      () => {
        if (onResizeComponent) {
          onResizeComponent(true);
        }
      }
    );
  };

  resetSession = async () => {
    const id = this.props.event.get('id');
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/sessions/events/${id}${WIX_INSTANCE_PARAMS}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.setState({
      orderError: false,
      session: data,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const updatedAttendees = this.findFormErrors();
    const attendeesWithErrors = this.state.isWaitlist ? updatedAttendees : this.findCustomFormErrors(updatedAttendees, this.state.event);
    this.setState({ attendees: attendeesWithErrors });
    if (attendeesWithErrors.every((err) => isEmpty(err.errors)) && attendeesWithErrors.every((err) => isEmpty(err.errors))) {
      return this.submitCheckout();
    }
    return true;
  };

  validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  findFormErrors = () =>
    this.state.attendees.map((attendee) => {
      const showConfirmEmail = this.props.settings.get('showConfirmEmail');

      const { first_name, last_name, email, confirm_email } = attendee.form || {};
      const newErrors = {};
      if (!first_name || first_name === '') newErrors.first_name = 'first name cannot be blank!';

      if (!last_name || last_name === '') newErrors.last_name = 'last name cannot be blank!';
      if (!email || email === '') newErrors.email = 'email cannot be blank!';
      else if (!this.validateEmail(email)) newErrors.email = 'Not a valid email!';
      else if (showConfirmEmail && email !== confirm_email) newErrors.confirm_email = 'Confirm email does not match';

      return { ...attendee, errors: newErrors };
    });

  findCustomFormErrors = (attendees, event) =>
    attendees.map((attendee, index) => {
      const ticketsIdToUUID = this.state.tickets.reduce((res, curr) => ({ ...res, [curr.get('id')]: curr.get('ticket_uuid') }), {});
      const ticketsInCart = Object.keys(this.state.cart).map((cartTicket) => ticketsIdToUUID[cartTicket]);

      const showAttendeeInputsPerTicket = this.props.settings.get('showAttendeeInputsPerTicket');

      const ticketList = showAttendeeInputsPerTicket
        ? Object.entries(this.state.cart).flatMap(([id, count]) => Array(count).fill(Number(id)))
        : [Object.keys(this.state.cart)[0]];

      const ticketId = showAttendeeInputsPerTicket ? ticketList[index] : null;
      const ticket = this.state.tickets.find((t) => +t.get('id') === +ticketId);

      const questions = filterConnectedTickets(event, showAttendeeInputsPerTicket, ticketsInCart, ticket ? ticket.get('ticket_uuid') : null);

      const requiredQuestions = questions.filter((q) => q.required).map((q) => q.question);

      const answers = attendee.custom_answers || {};
      const customErrors = requiredQuestions.reduce((res, requiredQuestion) => {
        const a = answers[requiredQuestion];
        if (!a || a === '') return { ...res, [`custom_${requiredQuestion}`]: 'An input is required here.' };
        return res;
      }, {});

      return { ...attendee, errors: { ...attendee.errors, ...customErrors } };
    });

  startSaving = () => {
    this.setState({
      saving: true,
      complete: false,
      orderError: false,
    });
  };
  stopSaving = () => {
    this.setState({
      saving: false,
      complete: false,
      orderError: false,
    });
  };

  submitCheckout = async (bankDetails = {}) => {
    const { session, onResizeComponent } = this.props;
    const { custom_answers, event, isWaitlist, attendees } = this.state;

    // Prepare event data for tracking
    const eventData = {
      event_category: 'Ticket',
      event_label: event.get('name'),
      currency: event.get('currency'),
      cart_id: this.state.session.idempotency_key,
    };

    // Google Analytics tracking
    if (window.gtag) {
      window.gtag('event', 'begin_checkout', eventData);
    }

    // Facebook Pixel tracking
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: event.get('name'),
        content_category: 'Ticket',
        contents: eventData.event_label,
        currency: eventData.currency,
        value: this.state.checkoutValues?.cartTotal || 0,
      });
    }
    if (event.get('event_setup') === 'rsvp') {
      const { first_name, last_name, email } = attendees[0].form || {};

      trackCustomerInfo(event, {
        first_name,
        last_name,
        email,
      });
    }

    // Track payment attempt
    trackPaymentAttempt(event, { cart_id: this.state.session.idempotency_key });

    if (bankDetails.error) {
      // Track payment failure
      trackPaymentResult(event, false, { error_message: bankDetails.error });

      // Google Analytics tracking for payment error
      if (window.gtag) {
        window.gtag('event', 'payment_error', {
          ...eventData,
          error_message: bankDetails.error,
        });
      }

      // Facebook Pixel tracking for payment error
      if (window.fbq) {
        window.fbq('trackCustom', 'PaymentError', {
          content_name: event.get('name'),
          content_category: 'Ticket',
          error_message: bankDetails.error,
        });
      }

      this.setState(
        {
          saving: false,
          complete: false,
          orderError: true,
          errorMessage: bankDetails.error,
        },
        () => {
          if (onResizeComponent) {
            onResizeComponent(true);
          }
        }
      );
      return;
    }

    this.startSaving();
    const answers = Object.keys(custom_answers).map((k) => ({
      question: k,
      answer: custom_answers[k],
    }));

    try {
      // Execute reCAPTCHA
      // const captchaToken = await this.recaptchaRef.current?.execute();
      // if (!captchaToken) {
      //   throw new Error('Failed to verify reCAPTCHA. Please try again.');
      // }

      const orderUrl = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${event.get('id')}/order${WIX_INSTANCE_PARAMS}`;
      const urlParams = new URLSearchParams(window.location.search);
      const trackingLinkId = urlParams.get('ts_tracking_id');

      // Assign attendeeIndex to each seat selection
      // Map seats to attendees in order (seat 0 → attendee 0, etc.)
      const seatSelectionsWithAttendeeIndex = this.state.seatSelections.map((seat, index) => ({
        ...seat,
        attendeeIndex: index,
      }));

      const orderPayload = {
        attendees: this.state.attendees,
        answers,
        is_waitlist_subscriber: isWaitlist,
        cart: this.state.cart,
        payment_type: session.payment_type,
        ...bankDetails,
        promo_code: this.state.promo_code,
        access_code: this.state.access_code,
        idempotency_key: this.state.session.idempotency_key,
        ticket_overrides: this.state.ticketOverrides,
        deferred_checkout: isShopifyEvent,
        // 'g-recaptcha-response': captchaToken,
        // Seating chart selections with attendee mapping
        seat_selections: seatSelectionsWithAttendeeIndex,
        seat_hold_token: this.state.seatHoldToken,
      };

      if (trackingLinkId) {
        orderPayload.tracking_link_id = trackingLinkId;
      }

      const { data } = await axios.post(orderUrl, orderPayload, {
        withCredentials: true,
      });

      // Track payment success
      trackPaymentResult(event, true, {
        order_id: data.id || data.order_id,
        cart_id: this.state.session.idempotency_key,
      });

      // Prepare successful payment data for tracking
      const purchaseData = {
        event_category: 'Ticket',
        event_label: event.get('name'),
        transaction_id: data.id || data.order_id,
        currency: event.get('currency'),
        value: this.state.checkoutValues?.cartTotal || 0,
        items: Object.entries(this.state.cart).map(([id, quantity]) => {
          const ticket = this.state.tickets.find((t) => t.get('id') === id);
          return {
            item_id: id,
            item_name: ticket ? ticket.get('name') : 'Unknown ticket',
            price: ticket ? ticket.get('price') : 0,
            quantity,
          };
        }),
      };

      // Google Analytics tracking for successful purchase
      if (window.gtag) {
        window.gtag('event', 'purchase', purchaseData);
      }

      // Facebook Pixel tracking for successful purchase
      if (window.fbq) {
        window.fbq('track', 'Purchase', {
          content_name: event.get('name'),
          content_category: 'Ticket',
          content_ids: Object.keys(this.state.cart),
          content_type: 'product',
          currency: event.get('currency'),
          value: this.state.checkoutValues?.cartTotal || 0,
          num_items: Object.values(this.state.cart).reduce((sum, qty) => sum + qty, 0),
        });
      }

      // Handle POS payment deep link
      if (data.payment_pending && data.pos_deep_link) {
        // Redirect to Square POS app via deep link
        window.location.href = data.pos_deep_link;
        return;
      }

      this.setState(
        {
          saving: false,
          complete: true,
          confirmMessage: data.confirmation_message,
          orderConfirmationUrl: data.order_confirmation_url || '',
        },
        () => {
          if (onResizeComponent) {
            onResizeComponent(true);
          }
          scrollToTicketElement();
        }
      );

      if (isShopifyEvent) {
        window.parent.postMessage({ type: 'ticket-spot-deferred-checkout', value: JSON.stringify(data) }, '*');
      }
    } catch (e) {
      errorHander(e);

      const errorMessage =
        e?.response?.data.error || e?.response?.data || 'There was a problem making the payment. Please ensure all your payment details are correct';
      // Track payment failure
      trackPaymentResult(event, false, { error_message: errorMessage });

      // Prepare error data for tracking
      const errorData = {
        event_category: 'Ticket',
        event_label: event.get('name'),
        currency: event.get('currency'),
        error_message: errorMessage,
      };

      // Google Analytics tracking for payment error
      if (window.gtag) {
        window.gtag('event', 'payment_error', errorData);
      }

      // Facebook Pixel tracking for payment error
      if (window.fbq) {
        window.fbq('trackCustom', 'PaymentError', {
          content_name: event.get('name'),
          content_category: 'Ticket',
          error_message: e?.response?.data || 'Payment processing error',
        });
      }

      this.setState(
        {
          saving: false,
          complete: false,
          orderError: true,
          errorMessage,
        },
        () => {
          if (onResizeComponent) {
            onResizeComponent(true);
          }
        }
      );
    }
  };

  removeZeroQuantity(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => +v !== 0));
  }

  handleTicketOverride = (ticketId, price) => {
    this.setState(
      {
        ticketOverrides: { ...this.state.handleTicketOverride, [ticketId]: price },
      },
      () => {
        this.handleCartUpdate(this.props.settings, this.state.event)(null, null, this.state.promo_code);
      }
    );
  };
  handleCartUpdate = (settings, event, initializeCart) => async (ticketId, quantity) => {
    this.setState({
      loadingCheckoutValues: true,
      orderError: false,
      errorMessage: '',
    });

    let newManualCart = this.state.manualCart;
    let newCart = this.state.cart;

    // If ticketId and quantity provided, update manual cart
    if (ticketId !== null && quantity !== null) {
      const manualTickets = {
        ...(initializeCart ? {} : this.state.manualCart),
        [ticketId]: quantity,
      };
      newManualCart = this.removeZeroQuantity(manualTickets);

      // Merge manual cart with seat quantities
      const seatQuantities = this.getSeatQuantities();
      const mergedCart = { ...newManualCart };

      // Add seat quantities
      Object.keys(seatQuantities).forEach((tId) => {
        mergedCart[tId] = (mergedCart[tId] || 0) + seatQuantities[tId];
      });

      newCart = this.removeZeroQuantity(mergedCart);
    }
    const showAttendeeInputsPerTicket = settings.get('showAttendeeInputsPerTicket');

    const ticketList = showAttendeeInputsPerTicket
      ? Object.entries(newCart).flatMap(([id, count]) => Array(count).fill(Number(id)))
      : [Object.keys(this.state.cart)[0]];
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${event.get('id')}/checkout${WIX_INSTANCE_PARAMS}`;

    try {
      const { data } = await axios.post(
        url,
        {
          cart: newCart,
          promo_code: this.state.promo_code,
          ticket_overrides: this.state.ticketOverrides,
        },
        { withCredentials: true }
      );

      this.setState({
        cart: newCart,
        manualCart: newManualCart,
        checkoutValues: data,
        loadingCheckoutValues: false,
        attendees: ticketList.map((tId) => ({ ticketId: tId })),
        orderError: false,
        errorMessage: '',
      });
      this.props.onResizeComponent && this.props.onResizeComponent();
    } catch (error) {
      errorHander(error);
      this.setState({
        loadingCheckoutValues: false,
        orderError: true,
        errorMessage: error.response?.data?.message || 'An error occurred while updating your cart. Please try again.',
      });
      throw error;
    }
  };

  handleCardSelection = (card) => {
    this.setState({
      selectedCard: this.state.session.cards.find(({ id }) => id === card.value),
    });
  };

  handleTicketUpdate =
    (event) =>
    ({ promo_code, access_code }) => {
      const updateState = {};
      if (promo_code !== undefined) {
        updateState.promo_code = promo_code;
      }
      if (access_code !== undefined) {
        updateState.access_code = access_code;
      }

      this.setState({
        ...updateState,
        loadingCheckoutValues: true,
      });

      const checkoutSummaryUrl = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${event.get('id')}/checkout${WIX_INSTANCE_PARAMS}`;
      axios
        .post(
          checkoutSummaryUrl,
          {
            cart: this.state.cart,
            promo_code: promo_code !== undefined ? promo_code : this.state.promo_code,
            access_code: access_code !== undefined ? access_code : this.state.access_code,
            ticket_overrides: this.state.ticketOverrides,
          },
          { withCredentials: true }
        )
        .then(({ data }) => {
          this.setState({
            checkoutValues: data,
            loadingCheckoutValues: false,
          });
        });
      this.props.onResizeComponent && this.props.onResizeComponent();
    };
  handleInitTicketStateChange = () => {
    this.setState({
      loadingCheckoutValues: true,
    });
  };

  handleSetCurrentStep = (value) => {
    this.setState({
      currentStep: value,
    });
  };
  handleBackStep = () => {
    const { onResizeComponent } = this.props;
    const { currentStep, isWaitlist, stepBeforeWaitlist, eventBeforeWaitlist, ticketsBeforeWaitlist } = this.state;

    // If in waitlist mode and on first step, restore previous state
    if (isWaitlist && currentStep === 0) {
      this.setState({
        isWaitlist: false,
        currentStep: stepBeforeWaitlist || 0,
        event: eventBeforeWaitlist || this.props.event,
        tickets: ticketsBeforeWaitlist || this.props.tickets,
        stepBeforeWaitlist: null,
        eventBeforeWaitlist: null,
        ticketsBeforeWaitlist: null,
      });
      onResizeComponent && onResizeComponent();
      return;
    }

    // Normal back step behavior
    if (currentStep <= 0) return;

    this.setState({
      currentStep: currentStep - 1,
    });

    onResizeComponent && onResizeComponent();
  };

  handleChangeActiveStep = (currentStep) => {
    this.setState({
      currentStep,
    });
  };

  handleWaitlistTicketClick = () => {
    const { onResizeComponent } = this.props;
    this.setState(
      {
        isWaitlist: true,
        currentStep: 0,
        stepBeforeWaitlist: this.state.currentStep,
        eventBeforeWaitlist: this.state.event,
        ticketsBeforeWaitlist: this.state.tickets,
      },
      () => {
        onResizeComponent();
      }
    );
  };

  handleUpdateTicketsList = (tickets) => {
    this.setState({
      tickets,
    });
  };

  render() {
    const { settings, onResizeComponent } = this.props;
    const { tickets, session, event, isWaitlist } = this.state;
    const isMobile = window.isMobileType;
    const { payment = {}, payment_type } = session;
    const button = !this.state.complete ? (
      <E.CustomButton
        variant="primary"
        onClick={this.handleSubmit}
        disabled={this.state.saving}
        className={cn('attendee_button', {
          'square-buttons': !settings.get('buttonRounded'),
          'button-saving': this.state.saving,
        })}
      >
        {this.state.saving && !this.state.orderError && (
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className={styles.spinner} />
        )}
        {isWaitlist ? event.get('waitlist_call_to_action') : settings.get('checkoutButtonText')}
      </E.CustomButton>
    ) : (
      <span />
    );

    const validateCart = () => {
      if (isEmpty(this.state.cart)) return false;

      // Check if at least one ticket in cart is available for purchase
      if (!hasAvailableTicketsInCart(this.state.cart, this.state.tickets)) {
        return false;
      }

      const inCartTicketsIds = Object.keys(this.state.cart);
      const ticketsWithDonations = this.state.tickets.filter(
        (ticket) => !!ticket.get('pay_what_you_want') && inCartTicketsIds.includes(ticket.get('id').toString())
      );

      if (ticketsWithDonations.size) {
        const allValid = ticketsWithDonations.every((ticket) => {
          const priceBase = ticket.get('pay_what_you_want') ? this.state.ticketOverrides[+ticket.get('id')] || 0 : ticket.get('price');
          const price = priceBase * this.state.cart[ticket.get('id')];
          const priceStr = price.toString();
          const validationError = validatePrice(priceStr, ticket);

          if (validationError) {
            this.setState({
              errors: {
                payWhatYouWantError: true,
              },
            });
            return false;
          }
          return true;
        });

        return allValid;
      }
      return true;
    };

    if (this.state.complete) {
      if (this.state.orderConfirmationUrl) {
        return (
          <div className={`${styles.ticketsSuccess} checkout-success-text`}>
            <ConfirmationIframe url={this.state.orderConfirmationUrl} onResizeComponent={onResizeComponent} />
          </div>
        );
      }
      return (
        <div
          className={`${styles.ticketsSuccess} checkout-success-text`}
          dangerouslySetInnerHTML={{
            __html: this.state.confirmMessage,
          }}
        />
      );
    }

    const showAttendeeInputsPerTicket = settings.get('showAttendeeInputsPerTicket');
    const ticketList = showAttendeeInputsPerTicket
      ? Object.entries(this.state.cart).flatMap(([id, count]) => Array(count).fill(Number(id)))
      : [Object.keys(this.state.cart)[0]].filter(Boolean);

    const calendarTicketSteps = [
      {
        label: settings.get('checkoutAttendeeDatesStepText'),
        description: (
          <DatetimeCheckoutController
            settings={settings}
            event={event}
            setEvent={(selectedEvent) => {
              const isWaitlistEventFull = waitlistEventFull(selectedEvent, selectedEvent.get('tickets'));
              if (selectedEvent.get('tickets')?.size === 1) {
                this.setState({
                  cart: this.setupInitialCart(selectedEvent.get('tickets')),
                });
                this.handleCartUpdate(this.props.settings, this.state.event, true)(
                  selectedEvent.getIn(['tickets', 0, 'id']),
                  1,
                  this.state.promo_code
                );
              }
              this.setState({
                event: selectedEvent,
                tickets: selectedEvent.get('tickets'),
                isWaitlist: isWaitlistEventFull,
                currentStep: isWaitlistEventFull ? 0 : this.state.currentStep,
              });
            }}
            setTickets={this.handleUpdateTicketsList}
            variant="calendar"
            occurrences={this.props.occurrences}
            calendarMetadata={this.props.calendarMetadata}
            calendarLoading={this.props.calendarLoading}
            onCalendarMonthChange={this.props.onCalendarMonthChange}
            pagination={this.props.pagination}
            onLoadMoreOccurrences={this.props.onLoadMoreOccurrences}
            setOccurrencesDate={this.setOccurrencesDate}
            onResizeComponent={onResizeComponent}
          />
        ),
        validate: () => () => true,
        shouldSkip: () => false,
      },
      {
        label: settings.get('checkoutAttendeeTimesStepText'),
        description: (
          <DatetimeCheckoutController
            settings={settings}
            event={event}
            setEvent={(selectedEvent) => {
              const isWaitlistEventFull = waitlistEventFull(selectedEvent, selectedEvent.get('tickets'));
              if (selectedEvent.get('tickets')?.size === 1) {
                this.setState({
                  cart: this.setupInitialCart(selectedEvent.get('tickets')),
                });
                this.handleCartUpdate(this.props.settings, this.state.event, true)(
                  selectedEvent.getIn(['tickets', 0, 'id']),
                  1,
                  this.state.promo_code
                );
              }
              this.setState({
                event: selectedEvent,
                tickets: selectedEvent.get('tickets'),
                isWaitlist: isWaitlistEventFull,
                currentStep: isWaitlistEventFull ? 0 : this.state.currentStep,
              });
            }}
            setTickets={this.handleUpdateTicketsList}
            setOccurrencesDate={this.setOccurrencesDate}
            variant="common"
            occurrenceDate={this.state.occurrenceDate}
            occurrences={this.props.occurrences}
            pagination={this.props.pagination}
            onLoadMoreOccurrences={this.props.onLoadMoreOccurrences}
            onClickBack={this.handleSetCurrentStep}
            onResizeComponent={onResizeComponent}
          />
        ),
        validate: () => () => true,
        shouldSkip: () => false,
      },
      {
        label: settings.get('checkoutAttendeeTicketsStepText'),
        description: (
          <TicketCheckoutForm
            tickets={this.state.tickets}
            hasAccessCodeControllerTickets={this.props.hasAccessCodeControllerTickets}
            loadingCheckoutValues={this.state.loadingCheckoutValues}
            paymentAccount={session.payment[session.payment_type]}
            event={event}
            key={event.get('id')}
            settings={settings}
            cart={this.state.cart}
            promoCode={this.state.promo_code}
            accessCode={this.state.access_code}
            onCartUpdate={this.handleCartUpdate(settings, event)}
            handleTicketOverride={this.handleTicketOverride}
            checkoutValues={this.state.checkoutValues}
            handleTicketUpdate={this.handleTicketUpdate(event)}
            handleUpdateTicketsList={this.handleUpdateTicketsList}
            ticketOverrides={this.state.ticketOverrides}
            handleInitTicketStateChange={this.handleInitTicketStateChange}
            errors={this.state.errors}
            handleWaitlistTicketClick={this.handleWaitlistTicketClick}
            onResizeComponent={onResizeComponent}
          />
        ),
        validate: validateCart,
        shouldSkip: () => false,
      },
      {
        label: settings.get('checkoutAttendeeDetailsStepText'),
        description: ticketList.map((ticketId, index) => (
          <TicketForm
            isMobile={isMobile}
            ticketId={ticketId}
            checkoutValues={this.state.checkoutValues}
            session={session}
            complete={this.state.complete}
            confirmMessage={this.state.confirmMessage}
            orderConfirmationUrl={this.state.orderConfirmationUrl}
            event={event}
            settings={settings}
            setCustomField={this.setCustomField(index)}
            setField={this.setField(index)}
            errors={this.state.attendees[index]?.errors}
            form={this.state.attendees[index].form}
            attendeeIndex={index + 1}
            cart={this.state.cart}
            onBack={this.handleSetCurrentStep}
            tickets={tickets}
            isWaitList={this.state.isWaitlist}
            onResizeComponent={onResizeComponent}
          />
        )),
        shouldSkip: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, this.state.event);
          return updateAttendees.every((e) => isEmpty(e.errors)) && newAttendees.every((e) => isEmpty(e.errors));
        },
        validate: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, this.state.event);
          this.setState({ attendees: newAttendees });
          if (newAttendees.every((e) => isEmpty(e.errors)) || newAttendees.every((e) => isEmpty(e.errors))) {
            return true;
          }
          return false;
        },
      },
      !isShopifyEvent
        ? {
            label: settings.get('checkoutAttendeePaymentStepText'),
            description: !this.state.orderError ? (
              <Payment
                settings={settings}
                session={session}
                key={event.get('id')}
                eventId={event.get('id')}
                currency={event.get('currency')}
                form={this.state.attendees.length > 0 ? this.state.attendees[0].form : {}}
                promo_code={this.state.promo_code}
                access_code={this.state.access_code}
                tickets={tickets}
                cart={this.state.cart}
                selectedCard={this.state.selectedCard}
                onPaymentSubmit={this.submitCheckout}
                onSave={this.startSaving}
                onFail={this.stopSaving}
                onBack={this.handleBackStep}
                setConfirmationEmail={this.setConfirmationEmail}
                handleCheckoutError={this.handleCheckoutError}
                isMobile={isMobile}
                event={event}
                attendees={this.state.attendees}
                checkoutValues={this.state.checkoutValues}
                onResizeComponent={onResizeComponent}
                ticketOverrides={this.state.ticketOverrides}
                paymentType={payment_type}
                payment={payment}
                handleTicketUpdate={this.handleTicketUpdate(event)}
                resetSession={this.resetSession}
                handleInitTicketStateChange={this.handleInitTicketStateChange}
                seatSelections={this.state.seatSelections}
                seatHoldToken={this.state.seatHoldToken}
              >
                {button}
              </Payment>
            ) : (
              <div className={styles.errorContainer}>
                <p className={styles.errorMessage}>Oops! Something went wrong.</p>
                <p className={styles.errorDetails}>{this.state.errorMessage}</p>
                <button
                  className={styles.resetButton}
                  onClick={async () => {
                    await this.resetSession();
                  }}
                >
                  Retry
                </button>
              </div>
            ),
            validate: () => true,
            shouldSkip: () => false,
          }
        : false,
    ].filter(Boolean);

    const datetimeTicketStep = [
      this.props?.occurrences?.size > 0 &&
        this.props.event.get('is_series_parent') && {
          label: settings.get('checkoutAttendeeDateTimeStepText'),
          description: (
            <DatetimeCheckoutController
              settings={settings}
              event={event}
              setEvent={(selectedEvent) => {
                const isWaitlistEventFull = waitlistEventFull(selectedEvent, selectedEvent.get('tickets'));
                if (selectedEvent.get('tickets')?.size === 1) {
                  this.setState({
                    cart: this.setupInitialCart(selectedEvent.get('tickets')),
                  });
                  this.handleCartUpdate(this.props.settings, this.state.event, true)(
                    selectedEvent.getIn(['tickets', 0, 'id']),
                    1,
                    this.state.promo_code
                  );
                }
                this.setState({
                  event: selectedEvent,
                  tickets: selectedEvent.get('tickets'),
                  isWaitlist: isWaitlistEventFull,
                  currentStep: isWaitlistEventFull ? 0 : this.state.currentStep,
                });
              }}
              setTickets={this.handleUpdateTicketsList}
              variant="common"
              occurrences={this.props.occurrences}
              pagination={this.props.pagination}
              onLoadMoreOccurrences={this.props.onLoadMoreOccurrences}
              setOccurrencesDate={this.setOccurrencesDate}
              onResizeComponent={onResizeComponent}
            />
          ),
          validate: () => () => true,
          shouldSkip: () => false,
        },
      {
        label: settings.get('checkoutAttendeeTicketsStepText'),
        description: (
          <TicketCheckoutForm
            tickets={this.state.tickets}
            hasAccessCodeControllerTickets={this.props.hasAccessCodeControllerTickets}
            loadingCheckoutValues={this.state.loadingCheckoutValues}
            paymentAccount={session.payment[session.payment_type]}
            event={event}
            key={event.get('id')}
            settings={settings}
            cart={this.state.cart}
            promoCode={this.state.promo_code}
            accessCode={this.state.access_code}
            onCartUpdate={this.handleCartUpdate(settings, event)}
            handleTicketOverride={this.handleTicketOverride}
            checkoutValues={this.state.checkoutValues}
            handleTicketUpdate={this.handleTicketUpdate(event)}
            handleUpdateTicketsList={this.handleUpdateTicketsList}
            ticketOverrides={this.state.ticketOverrides}
            handleInitTicketStateChange={this.handleInitTicketStateChange}
            errors={this.state.errors}
            handleWaitlistTicketClick={this.handleWaitlistTicketClick}
            onResizeComponent={onResizeComponent}
          />
        ),
        validate: validateCart,
        shouldSkip: () => false,
      },
      {
        label: settings.get('checkoutAttendeeDetailsStepText'),
        description: ticketList.map((ticketId, index) => (
          <TicketForm
            isMobile={isMobile}
            ticketId={ticketId}
            checkoutValues={this.state.checkoutValues}
            session={session}
            complete={this.state.complete}
            confirmMessage={this.state.confirmMessage}
            orderConfirmationUrl={this.state.orderConfirmationUrl}
            event={event}
            settings={settings}
            setCustomField={this.setCustomField(index)}
            setField={this.setField(index)}
            errors={this.state.attendees[index]?.errors}
            form={this.state.attendees[index].form}
            attendeeIndex={index + 1}
            cart={this.state.cart}
            onBack={this.handleSetCurrentStep}
            tickets={tickets}
            isWaitList={this.state.isWaitlist}
            onResizeComponent={onResizeComponent}
          />
        )),
        shouldSkip: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, this.state.event);
          return updateAttendees.every((e) => isEmpty(e.errors)) && newAttendees.every((e) => isEmpty(e.errors));
        },
        validate: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, this.state.event);
          this.setState({ attendees: newAttendees });
          if (newAttendees.every((e) => isEmpty(e.errors)) || newAttendees.every((e) => isEmpty(e.errors))) {
            return true;
          }
          return false;
        },
      },
      !isShopifyEvent
        ? {
            label: settings.get('checkoutAttendeePaymentStepText'),
            description: !this.state.orderError ? (
              <Payment
                settings={settings}
                session={session}
                key={event.get('id')}
                eventId={event.get('id')}
                currency={event.get('currency')}
                form={this.state.attendees.length > 0 ? this.state.attendees[0].form : {}}
                promo_code={this.state.promo_code}
                access_code={this.state.access_code}
                tickets={tickets}
                cart={this.state.cart}
                selectedCard={this.state.selectedCard}
                onPaymentSubmit={this.submitCheckout}
                onSave={this.startSaving}
                onFail={this.stopSaving}
                onBack={this.handleBackStep}
                setConfirmationEmail={this.setConfirmationEmail}
                handleCheckoutError={this.handleCheckoutError}
                isMobile={isMobile}
                event={event}
                attendees={this.state.attendees}
                checkoutValues={this.state.checkoutValues}
                onResizeComponent={onResizeComponent}
                ticketOverrides={this.state.ticketOverrides}
                paymentType={payment_type}
                payment={payment}
                handleTicketUpdate={this.handleTicketUpdate(event)}
                resetSession={this.resetSession}
                handleInitTicketStateChange={this.handleInitTicketStateChange}
                seatSelections={this.state.seatSelections}
                seatHoldToken={this.state.seatHoldToken}
              >
                {button}
              </Payment>
            ) : (
              <div className={styles.errorContainer}>
                <p className={styles.errorMessage}>Oops! Something went wrong.</p>
                <p className={styles.errorDetails}>{this.state.errorMessage}</p>
                <button
                  className={styles.resetButton}
                  onClick={async () => {
                    await this.resetSession();
                  }}
                >
                  Retry
                </button>
              </div>
            ),
            validate: () => true,
            shouldSkip: () => false,
          }
        : false,
    ].filter(Boolean);

    const defaultTicketSteps = [
      // Single ticket step with seating chart on top and non-seated tickets below
      {
        label: settings.get('checkoutAttendeeTicketsStepText'),
        description: (
          <TicketCheckoutForm
            tickets={this.state.tickets}
            hasAccessCodeControllerTickets={this.props.hasAccessCodeControllerTickets}
            loadingCheckoutValues={this.state.loadingCheckoutValues}
            paymentAccount={session.payment[session.payment_type]}
            event={event}
            key={event.get('id')}
            settings={settings}
            cart={this.state.cart}
            promoCode={this.state.promo_code}
            accessCode={this.state.access_code}
            onCartUpdate={this.handleCartUpdate(settings, event)}
            handleTicketOverride={this.handleTicketOverride}
            checkoutValues={this.state.checkoutValues}
            handleTicketUpdate={this.handleTicketUpdate(event)}
            handleUpdateTicketsList={this.handleUpdateTicketsList}
            ticketOverrides={this.state.ticketOverrides}
            handleInitTicketStateChange={this.handleInitTicketStateChange}
            errors={this.state.errors}
            handleWaitlistTicketClick={this.handleWaitlistTicketClick}
            onResizeComponent={onResizeComponent}
            // Seating props
            hasSeatingChart={this.state.hasSeatingChart}
            seatingChartLoading={this.state.seatingChartLoading}
            seatSelections={this.state.seatSelections}
            onSeatSelection={(seatData) => {
              // Update seat selections
              let newSelections = [...this.state.seatSelections];

              if (seatData.action === 'select') {
                // Add seat if not already in list
                if (!newSelections.some((s) => s.seatId === seatData.seatId)) {
                  newSelections.push(seatData);
                }
              } else if (seatData.action === 'deselect') {
                // Remove seat
                newSelections = newSelections.filter((s) => s.seatId !== seatData.seatId);
              }

              this.setState({ seatSelections: newSelections }, () => {
                // Calculate seat quantities
                const seatQuantities = {};
                newSelections.forEach((seat) => {
                  if (seat.ticketId) {
                    seatQuantities[seat.ticketId] = (seatQuantities[seat.ticketId] || 0) + 1;
                  }
                });

                // Merge manual cart with seat quantities
                const mergedCart = { ...this.state.manualCart };
                Object.keys(seatQuantities).forEach((ticketId) => {
                  mergedCart[ticketId] = (mergedCart[ticketId] || 0) + seatQuantities[ticketId];
                });

                const newCart = this.removeZeroQuantity(mergedCart);

                this.setState({ cart: newCart }, () => {
                  // Trigger checkout values update
                  this.handleCartUpdate(settings, event)(null, null);
                });
              });
            }}
            onHoldTokenGenerated={(holdToken) => {
              this.setState({ seatHoldToken: holdToken });
            }}
          />
        ),
        validate: validateCart,
        shouldSkip: () => false,
      },
      {
        label: settings.get('checkoutAttendeeDetailsStepText'),
        description: ticketList.map((ticketId, index) => (
          <TicketForm
            isMobile={isMobile}
            ticketId={ticketId}
            session={session}
            checkoutValues={this.state.checkoutValues}
            complete={this.state.complete}
            confirmMessage={this.state.confirmMessage}
            orderConfirmationUrl={this.state.orderConfirmationUrl}
            event={event}
            settings={settings}
            setCustomField={this.setCustomField(index)}
            setField={this.setField(index)}
            errors={this.state.attendees[index]?.errors}
            form={this.state.attendees[index].form}
            attendeeIndex={index + 1}
            cart={this.state.cart}
            onBack={this.handleSetCurrentStep}
            tickets={tickets}
            isWaitList={this.state.isWaitlist}
            onResizeComponent={onResizeComponent}
          />
        )),
        shouldSkip: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, event);
          return updateAttendees.every((e) => isEmpty(e.errors)) && newAttendees.every((e) => isEmpty(e.errors));
        },
        validate: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, event);
          this.setState({ attendees: newAttendees });
          if (newAttendees.every((e) => isEmpty(e.errors)) || newAttendees.every((e) => isEmpty(e.errors))) {
            return true;
          }
          return false;
        },
      },
      !isShopifyEvent
        ? {
            label: settings.get('checkoutAttendeePaymentStepText'),
            description: !this.state.orderError ? (
              <Payment
                settings={settings}
                session={session}
                key={event.get('id')}
                eventId={event.get('id')}
                currency={event.get('currency')}
                form={this.state.attendees.length > 0 ? this.state.attendees[0].form : {}}
                promo_code={this.state.promo_code}
                tickets={tickets}
                cart={this.state.cart}
                selectedCard={this.state.selectedCard}
                onPaymentSubmit={this.submitCheckout}
                onSave={this.startSaving}
                onFail={this.stopSaving}
                onBack={this.handleBackStep}
                setConfirmationEmail={this.setConfirmationEmail}
                handleCheckoutError={this.handleCheckoutError}
                isMobile={isMobile}
                event={event}
                attendees={this.state.attendees}
                checkoutValues={this.state.checkoutValues}
                onResizeComponent={onResizeComponent}
                ticketOverrides={this.state.ticketOverrides}
                paymentType={payment_type}
                payment={payment}
                handleTicketUpdate={this.handleTicketUpdate(event)}
                resetSession={this.resetSession}
                handleInitTicketStateChange={this.handleInitTicketStateChange}
                handleWaitlistTicketClick={this.handleWaitlistTicketClick}
                seatSelections={this.state.seatSelections}
                seatHoldToken={this.state.seatHoldToken}
              >
                {button}
              </Payment>
            ) : (
              <div className={styles.errorContainer}>
                <p className={styles.errorMessage}>Oops! Something went wrong.</p>
                <p className={styles.errorDetails}>{this.state.errorMessage}</p>
                <button
                  className={styles.resetButton}
                  onClick={async () => {
                    await this.resetSession();
                  }}
                >
                  Retry
                </button>
              </div>
            ),
            validate: () => true,
            shouldSkip: () => false,
          }
        : false,
    ].filter(Boolean);

    const defaultWaitlistSteps = [
      {
        label: settings.get('checkoutAttendeeWaitlistDetailsStepText'),
        description: (ticketList.length === 0 ? [1] : ticketList).map((ticketId, index) => (
          <TicketForm
            isMobile={isMobile}
            ticketId={ticketId}
            checkoutValues={this.state.checkoutValues}
            session={session}
            isWaitList={this.state.isWaitlist}
            complete={this.state.complete}
            confirmMessage={this.state.confirmMessage}
            orderConfirmationUrl={this.state.orderConfirmationUrl}
            event={event}
            settings={settings}
            setCustomField={this.setCustomField(index)}
            setField={this.setField(index)}
            errors={this.state.attendees[index]?.errors}
            form={this.state.attendees[index]?.form || {}}
            attendeeIndex={index + 1}
            cart={this.state.cart}
            onBack={this.handleSetCurrentStep}
            tickets={tickets}
            onResizeComponent={onResizeComponent}
          />
        )),
        shouldSkip: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, event);
          return updateAttendees.every((e) => isEmpty(e.errors)) && newAttendees.every((e) => isEmpty(e.errors));
        },
        validate: () => {
          const updateAttendees = this.findFormErrors();
          const newAttendees = this.findCustomFormErrors(updateAttendees, event);
          this.setState({ attendees: newAttendees });
          if (newAttendees.every((e) => isEmpty(e.errors)) || newAttendees.every((e) => isEmpty(e.errors))) {
            return true;
          }
          return false;
        },
      },
    ];

    const currentSteps = () => {
      if (this.state.isWaitlist) {
        return defaultWaitlistSteps;
      }
      if (
        this.state.event.get('series_id') ||
        this.state.event.get('is_recurring') ||
        this.state.event.get('is_time_based') ||
        this.state.event.get('is_timed_entry_event')
      ) {
        if (this.props.settings.get('timeBasedEventLayout') === 'desktop-full-calendar') return calendarTicketSteps.filter(Boolean);
        return datetimeTicketStep.filter(Boolean);
      }
      return defaultTicketSteps.filter(Boolean);
    };

    const currentStep = session && session.cards && this.state.selectedCard ? currentSteps().length - 1 : this.state.currentStep;

    const isAttendeeButtonShow = () => {
      const isLastEntry = currentStep === currentSteps().length - 1;

      if (isLastEntry && isShopifyEvent) return true;
      if (isLastEntry && this.state.isWaitlist) return true;
      if (!isLastEntry) return false;
      if (this.state.event.get('series_id') || this.state.event.get('is_recurring') || this.state.event.get('is_time_based')) {
        return !!this.state.occurrenceDate;
      }
      return false;
    };

    const eventCapacityWaitlist = this.state.isWaitlist;
    return (
      <Container className={styles.container}>
        {/* <InvisibleRecaptcha ref={this.recaptchaRef} onLoad={() => this.setState({ recaptchaLoaded: true })} /> */}
        <Row
          className={cn(`checkout-form-container gap-3 tickets-${event.get('id')}`, { [styles.mobileCheckoutContainer]: isMobile })}
          ref={this.checkoutFormContainerRef}
          // style={{ minHeight: `${this.state.minHeight}px` }}
        >
          <Col className={styles.detailsSection}>
            <CheckoutProcessStepper
              cart={this.state.cart}
              event={event}
              isMobile={isMobile}
              initialActiveStep={session && session.cards && this.state.selectedCard ? currentSteps().length - 1 : 0}
              steps={currentSteps()}
              settings={settings}
              isCompleted={this.state.complete}
              onResizeComponent={onResizeComponent}
              activeStep={currentStep}
              setCurrentStep={this.handleChangeActiveStep}
              isWaitList={this.state.isWaitlist}
              isTimeBasedEvents={
                !!this.state.event.get('is_time_based') || !!this.state.event.get('is_recurring') || !!this.state.event.get('series_id')
              }
              tickets={this.state.tickets}
              occurrencesDate={this.state.occurrenceDate}
            />

            {!isShopifyEvent && !this.state.isWaitlist && isAttendeeButtonShow() && <Row className={styles.confirmQuestionsButton}>{button}</Row>}
            {isAttendeeButtonShow() && (currentStep === currentSteps().length - 1 || eventCapacityWaitlist) && (
              <StepButtonWrapper>
                <Button onClick={this.handleBackStep} className="checkout-prev-button checkout-back-button">
                  {settings.get('checkoutBackButtonText')}
                </Button>
                {button}
              </StepButtonWrapper>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}
